import { createSlice } from "@reduxjs/toolkit";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";


const initialState = {
    data: null,
};

export const paramSlice = createSlice({
    name: "param",
    initialState,
    reducers: {
        setParam: (state) => {
            state.data = state.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const { setParam } = paramSlice.actions;

export default paramSlice.reducer;

const apiUrl = process.env.REACT_APP_API_URL;

export const paramApi = createApi({
    reducerPath: "paramApi",
    baseQuery: fetchBaseQuery({
        baseUrl: apiUrl, // Utilisation du proxy
        prepareHeaders: (headers, { getState }) => {
            const token = JSON.parse(localStorage.getItem('auth'))?.jwt;

            // Si un token est disponible, ajoutez-le aux en-têtes
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            headers.set('Content-type', 'application/json');
            headers.set('Accept', 'application/json');
            return headers;
        },
    }),
    endpoints: (builder) => ({

        postParam: builder.mutation({
            query: (data) => ({
                url: `/${data.endpoint}`, // Appel via le proxy
                method: 'POST',
                body: { data },
            }),
        }),

        getParams: builder.query({
            query: (data) => ({
                url: `/${data.endpoint}?populate=*&pagination[page]=${data.page ? data.page : 1}&pagination[pageSize]=${data.size ? data.size : 10}&sort=id:desc`,
                method: 'GET',
            }),
        }),
        getParamById: builder.query({
            query: (data) => ({
                url: `/ ${data.endpoint} / ${data.id}`,
                method: 'GET',
            }),
        }),

        getParamByType: builder.query({
            query: (data) => ({
                url: `/${data.endpoint}?filters[type][id][$eq]=${data.id}`,
                method: 'GET',
            }),
        }),
        updateParam: builder.mutation({
            query: (data) => ({
                url: `/${data.endpoint}/${data.id}`, // Appel via le proxy
                method: 'PUT',
                body: { data },
            }),
        }),
    }),
});

// Export hooks pour une utilisation dans les composants fonctionnels
export const { usePostParamMutation, useLazyGetParamsQuery, useGetParamByIdQuery, useLazyGetParamByTypeQuery, useUpdateParamMutation } = paramApi;

